import "./Home.css";
const Home = () => {
  return (
    <>
      <h1>Start Your Code</h1>
    </>
  );
};

export default Home;
